import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { InspectionsPage } from '@/features/quality/inspections-page';

const searchSchema = z.object({
  request: z.string().optional().catch(undefined),
  inspection: z.string().optional().catch(undefined),
  new: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/quality/inspections/')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <InspectionsPage
      projectId={projectId}
      category="quality"
      requestId={search.request}
      inspectionId={search.inspection}
      create={search.new}
    />
  );
}
